<template>
    <el-switch v-if="showInput"
        class="filterItem-value"
        v-model="filterItem.value[0]"
        inline-prompt
        active-text="是"
        inactive-text="否"
        style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"
    />
</template>

<style>
    
</style>

<script>
    import baseFilter from "../../BaseFilter"

    export default {
        name:"BooleanFieldFilter",
        mixins:[baseFilter]
    }
</script>